declare var window: any;
import { ClassTransformOptions, Type, plainToClass } from 'class-transformer';
import Model from './Model';
import FeedbackQuestionTranslation from './FeedbackQuestionTranslation';

class FeedbackQuestion extends Model {

    id: number;

    @Type(() => FeedbackQuestionTranslation)
    translation: FeedbackQuestionTranslation;

    @Type(() => FeedbackQuestionTranslation)
    translations: FeedbackQuestionTranslation[];

    comment: string;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;


    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Get value
     *
     * @param {string} [locale]
     * @return {string}
     */
    value(locale?: string) {

        return (this as any).translateOrDefault(locale)?.value;
    }

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'FeedbackQuestion';
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): FeedbackQuestion[];
    static new(plain: {}, options?: ClassTransformOptions): FeedbackQuestion;
    static new(plain: {} | [], options?: ClassTransformOptions): FeedbackQuestion | FeedbackQuestion[] {
        return plainToClass(FeedbackQuestion, plain as any, options);
    }
}

export default FeedbackQuestion;
